export const statics = {
    filters: {
        ref_bike_brand: { title: 'Make' },
        ref_bike_model: { title: 'Model' },
        cc: { title: 'CC' },
        bike_type: { title: 'Type' },
        mileage_limit: { title: 'Mileage Limit' },
        min_age: { title: 'Min Age' },
        wwym_priority: { title: 'WWYM Priority' },
        leadomatic_priority: { title: 'LoM priority' },
        check_luggage: { title: 'Only with Luggage' },
        always_manual_price: { title: 'Only Manual Price Check' },
        check_race_replica: { title: 'Only Race Replica' },
        we_dont_want: { title: 'Only We Dont Want' },
        is_hot: { title: 'Only in Hot List' },
        is_no_buy: { title: 'Only in Cold List' },

        duplicate_min: { title: 'Only Duplicates' },
        duplicate_max: { title: 'Only Duplicates' },

    },
    titles: [
        { title: 'Leadomatic Priority', dataIndex: 'leadomatic_priority', _id: 'leadomatic_priority' },
        { title: 'Mileage Limit', dataIndex: 'mileage_limit', _id: 'mileage_limit' },
        { title: 'Age Limit', dataIndex: 'min_age', _id: 'min_age' },
    ],
    bike_priorities: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
    ],
    priorities: [0, 1, 2, 3, 4, 5],
    bike_min_age: [
        { value: 0, label: 'Not Set' },
        { value: 2000, label: '2000' },
        { value: 2001, label: '2001' },
        { value: 2002, label: '2002' },
        { value: 2003, label: '2003' },
        { value: 2004, label: '2004' },
        { value: 2005, label: '2005' },
        { value: 2006, label: '2006' },
        { value: 2007, label: '2007' },
        { value: 2008, label: '2008' },
        { value: 2009, label: '2009' },
        { value: 2010, label: '2010' },
        { value: 2011, label: '2011' },
        { value: 2012, label: '2012' },
        { value: 2013, label: '2013' },
        { value: 2014, label: '2014' },
    ],
    bike_mileage_limit: [
        { value: 0, label: 'Not Set' },
        { value: 5000, label: '5,000' },
        { value: 10000, label: '10,000' },
        { value: 15000, label: '15,000' },
        { value: 20000, label: '20,000' },
        { value: 25000, label: '25,000' },
        { value: 26000, label: '26,000' },
        { value: 27000, label: '27,000' },
        { value: 28000, label: '28,000' },
        { value: 29000, label: '29,000' },
        { value: 30000, label: '30,000' },
    ],
    bike_types: [
        'Adventure',
        'Classic',
        'Commuter',
        'Custom Cruiser',
        'Enduro',
        'Minibike',
        'Moped',
        'Moto Cross',
        'Naked',
        'Quad/ATV',
        'Roadster/Retro',
        'Scooter',
        'Sidecar',
        'Special',
        'Sports Tourer',
        'Super Moto',
        'Super Sports',
        'Supermoto-Road',
        'Three Wheeler',
        'Tourer',
        'Trail (Enduro)',
        'Trail Bike',
        'Trial Bike',
    ],
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/components/statics.js